import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PrivacyPolicy from './privacy';
import TermsOfService from './Terms';

export default function Footer() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer style={{
      ...styles.footer,
      flexDirection: isMobile ? 'column' : 'row',
      textAlign: isMobile ? 'center' : 'left',
      padding: isMobile ? '3rem 1.5rem' : '2.5rem clamp(1.5rem, 6vw, 5rem)',
    }}>
      <div style={styles.logoContainer}>
        <h1 style={styles.logo}>Shepherd</h1>
      </div>

      <div style={{ order: isMobile ? 3 : 2 }}>
        <h2 style={styles.copyright}>© 2026 Shepherd - A Luke Mancuso Product</h2>
      </div>

      <div style={{ 
        ...styles.links, 
        order: isMobile ? 2 : 3,
        justifyContent: isMobile ? 'center' : 'flex-end' 
      }}>
        <Link to="/legal" onClick={() => window.scrollTo(0, 0)} style={styles.linkButton}>Legal Hub</Link>  
        <a href="mailto:luke@startshepherd.com" style={styles.link}>Contact</a>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-between', 
    gap: '1.5rem',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    background: '#121212',
  },
  logo: { 
    fontFamily: 'magnolia-script', 
    color: '#4A90E2', 
    margin: 0,
    fontSize: '1.5rem'
  },
  links: { 
    display: 'flex', 
    gap: '1.5rem',
    flex: 1, // Helps with alignment logic
  },
  link: { fontSize: '0.82rem', color: 'rgba(255,255,255,0.3)', textDecoration: 'none' },
  linkButton: { 
    fontSize: '0.82rem', 
    color: 'rgba(255,255,255,0.3)', 
    background: 'none',
    border: 'none',
    textDecoration: 'none',
    padding: 0,
    cursor: 'pointer',
    fontFamily: 'inherit'
  },
  copyright: { 
    fontSize: '0.82rem', 
    color: 'rgba(255,255,255,0.3)',
    fontWeight: 400,
    margin: 0
  }
};